export const KILOMETERS = 'KILOMETERS';
export const MILES = 'MILES';
